import { s3base } from "api";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import React from "react";
import Contact from "assets/images/public-pages/green-contact.svg"
import { MdArrowOutward } from "react-icons/md";

function Branch({ branch }) {
  const openPopup = () => {
  const modal = new window.bootstrap.Modal(
    document.getElementById("staticBackdrop")
  );
  modal.show();
};

const countryCode = () =>{
if(branch?.country === "India"){  
return "IN"
}else if(branch?.country === "Australia"){
  return "AU"
}if(branch?.country === "Nepal"){
  return "NP"
}
}

  const branchTitle = () => {
    if (branch?.title === "Jalandhar") {
      return branch?.country + "· " + "Regional HQ";
    } else if (branch?.title === "Parramatta") {
      return branch?.country + "· " + "HQ";
    } else {
      return branch?.country || "";
    }
  }
  
  return (
    <>
      {branch && (
        <div className="branch-card branches-card">
          <div className="adresssBlockInr p-0">
            <div className="mapOuter d-flex align-items-center gap-3  ">
             <div className="country-code-box">
              {countryCode()}
             </div>
             <div>
               <h3 className="mb-0 top-section-text FS24FW500 fw-600">{branch?.title}</h3>
               <p className="noc-text-success FS16FW500 fw-600 mb-0">{branchTitle()}</p>
             </div>
            </div>
            <hr/>
            <div className="adressCntnt">
              <div className="addressInfo">
                <p className="plus-sans">{branch?.address}</p>
              </div>

              <div className="contactNo d-flex">
                <img src={Contact} alt="contact"/>
                <a href={"tel:" + branch.contact_number_to_dial}>
                  {branch?.contact_number_to_display}
                </a>
              </div>
            </div>     
          </div>
           <div className="locationBtn">
                <ButtonComp
                  link={openPopup}
                  btnText={"Book Visit"}
                  img="/images/web-new-images/new-dark-arrow.svg"
                  className={"to-unset-transform d-flex align-items-center gap-2 justify-content-center"}
                />
                <button
                  className="border-btn gap-2 primary-btn w-auto w-sm-auto to-unset-transform direction-btn"
                  onClick={() => window.open(branch?.direction_link, "_blank")}
                >
                Directions
                <span style={{marginLeft:"6px"}}>
                    <MdArrowOutward size={22}/>
                </span>
                </button>
              </div>
        </div>
      )}
    </>
  );
}

export default Branch;